import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/Kuber(White).png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NutritionalTable from "./NutritionalTable";
import { useMediaQuery, useTheme } from "@mui/material";

const KuberDiamond = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );
  const tableData = [
    { nutrient: "Protein", value: "23%" },
    { nutrient: "Fat", value: "3.5 - 4%" },
    { nutrient: "Fiber", value: "10%" },
    { nutrient: "Moisture", value: "10 - 11%" },
    { nutrient: "Insoluble Matter", value: "2%" },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div className={isMobile ? "product-image product-image--mobile" : "product-image"}>
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">
              KUBER DIAMOND{" "}
              <span
                style={{
                  fontFamily: "Playfair Display",
                  fontStyle: "italic",
                  color: "#ffc40c",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                }}
              >
                (Premium)
              </span>
            </div>
            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p>
                Introducing Kuber Diamond (TYPE - 1), a specially formulated
                cattle feed designed to optimize your herd's health and
                productivity. Available in convenient 8mm pellets, Kuber Diamond
                provides a balanced nutritional profile to support robust growth
                and peak performance
              </p>
              <p>
                Kuber Diamond is designed to provide comprehensive nutrition
                that supports your cattle’s growth, productivity, and
                well-being, making it the ideal choice for farmers who want the
                best for their livestock.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>
                    <b>Improved Digestive Efficiency: </b> With a specialized
                    buffer, Kuber Diamond maintains optimal pH balance in the
                    rumen, preventing digestive disturbances such as acidosis,
                    and ensuring that nutrients are absorbed more efficiently.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Consistent Energy Supply: </b>The combination of bypass
                    fat and grains delivers a reliable energy source that helps
                    cattle maintain high energy levels, supporting peak
                    performance whether in milk production or growth.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Balanced Muscle Growth & Milk Production: </b>The 23%
                    protein content, derived from high-quality sources like
                    soybean and cottonseed, ensures healthy muscle development
                    and enhanced milk production, while bypass protein ensures
                    efficient nutrient absorption. potential.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Healthy Digestive Function: </b>The high fiber content
                    (10%) promotes gut health, aiding in the smooth passage of
                    feed through the digestive system and reducing the risk of
                    digestive issues.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Enhanced Overall Health: </b>By maintaining a healthy
                    digestive system and providing balanced nutrition, Kuber
                    Diamond helps improve cattle immunity and reduces the
                    likelihood of health complications, leading to healthier,
                    more productive animals.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <NutritionalTable data={tableData} />
          </div>
          <div>
            <h3 className="benefits-title">Key Ingredients:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>Soybean</div>
                </li>
                <li>
                  <div>Grains</div>
                </li>
                <li>
                  <div>Bypass Fat and Protein</div>
                </li>
                <li>
                  <div>Rice Bran</div>
                </li>
                <li>
                  <div>Cottonseed</div>
                </li>
                <li>
                  <div>Buffer</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Kuber-diamond-pellets" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default KuberDiamond;
